<template>
    <v-layout justify-center>
        <v-dialog v-model="show" width="700px">
            <v-card>
                <v-toolbar dark color="blue lighten-2" class="titlebar">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Редактирование модуля: {{getTitleMethodById(Object.keys(structure)[0])}}</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" >
                            <v-icon>save</v-icon>
                            {{'\t\t Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container fluid>
                                <v-layout v-for="(functionName, index) in structure[Object.keys(structure)[0]]"
                                          :key="index"
                                >
                                    <v-flex xs12>
                                        {{getModuleTitle(index)}}
                                        <v-col cols="12" md12>
                                            <v-btn
                                                    v-if="getModuleType(index)"
                                                    small
                                                    @click="addVariable(index)"
                                            >Добавить переменную</v-btn>
                                        </v-col>
                                        <div v-if="!getModuleType(index)">
                                            <v-col
                                                    cols="12"
                                                    md12
                                                    v-for="(cell, indexCell) in functionName"
                                                    :key="indexCell"
                                                    class="py-0 my-0"
                                            >
                                                <v-text-field
                                                        v-if="getGroupElement(index, cell[0]).type === 'input'"
                                                        v-model="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :label="getModuleLabel(index, cell[0])"
                                                        :type="getGroupElement(index, cell[0]).format"
                                                        required
                                                />
                                                <v-textarea
                                                        v-if="getGroupElement(index, cell[0]).type === 'text-area'"
                                                        v-model="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :label="getModuleLabel(index, cell[0])"
                                                        required
                                                        auto-grow
                                                        rows="1"
                                                />
                                                <v-select
                                                        v-if="getGroupElement(index, cell[0]).type === 'select'"
                                                        :items="getSelectItems(index, cell[0])"
                                                        :label="getModuleLabel(index, cell[0])"
                                                        :value="cell[1]"
                                                        v-model="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                />
                                                <v-switch
                                                    v-if="getGroupElement(index, cell[0]).type === 'switch'"
                                                    v-model="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                    inset
                                                    :label="getModuleLabel(index, cell[0])"
                                                    color="primary"
                                                    :false-value="0"
                                                    :true-value="1"
                                                />
                                                <module-combobox
                                                        v-if="getGroupElement(index, cell[0]).type === 'combobox'"
                                                        :model-items="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :label="getModuleLabel(index, cell[0])"
                                                        :params="getGroupElement(index, cell[0])"
                                                        :methodId="Object.keys(structure)[0]"
                                                        :index="index"
                                                        :indexCell="indexCell"
                                                        :load="dialog"
                                                        @updateItems="updateItemsCombobox"
                                                />
                                                <module-select
                                                        v-if="getGroupElement(index, cell[0]).type === 'selectBox'"
                                                        :model-items="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :label="getModuleLabel(index, cell[0])"
                                                        :params="getGroupElement(index, cell[0])"
                                                        :methodId="Object.keys(structure)[0]"
                                                        :index="index"
                                                        :indexCell="indexCell"
                                                        :load="dialog"
                                                        @updateItems="updateItemsCombobox"
                                                />
                                                <module-conditions
                                                        v-if="getGroupElement(index, cell[0]).type === 'conditions'"
                                                        :model-items="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :load="show"
                                                        :methodId="Object.keys(structure)[0]"
                                                        :index="index"
                                                        :indexCell="indexCell"
                                                />
                                                <module-variables-if-else-selects
                                                        v-if="getGroupElement(index, cell[0]).type === 'if_else_selects'"
                                                        :model-items="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :load="show"
                                                        :methodId="Object.keys(structure)[0]"
                                                        :index="index"
                                                        :indexCell="indexCell"
                                                />
                                                <module-variables-if-else-selects-array
                                                        v-if="getGroupElement(index, cell[0]).type === 'ifElseSelectsArray'"
                                                        :model-items="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :load="show"
                                                        :methodId="Object.keys(structure)[0]"
                                                        :index="index"
                                                        :indexCell="indexCell"
                                                />
                                                <module-market-conditions
                                                        v-if="getGroupElement(index, cell[0]).type === 'market_conditions'"
                                                        :model-items="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                        :load="show"
                                                        :methodId="Object.keys(structure)[0]"
                                                        :index="index"
                                                        :indexCell="indexCell"
                                                />
                                            </v-col>
                                        </div>
                                        <div v-if="getModuleType(index) === 1">
                                            <v-col
                                                    cols="12"
                                                    md10
                                                    v-for="(cell, indexCell) in functionName"
                                                    :key="indexCell"
                                            >
                                                <v-row
                                                        align="center"
                                                        justify="space-around"
                                                >
                                                <v-col
                                                        cols="9"
                                                        md10
                                                        class="ma-0 pa-0"
                                                >
                                                    <v-text-field
                                                            v-if="getGroupElement(index, cell[0]).type === 'input'"
                                                            v-model="structure[Object.keys(structure)[0]][index][indexCell][1]"
                                                            :label="getModuleLabel(index, cell[0])"
                                                            :type="getGroupElement(index, cell[0]).format"
                                                            hide-details
                                                            required
                                                    />
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        md="1"
                                                        class="ma-0 pa-0"
                                                        offset-md="1"
                                                >
                                                    <v-btn
                                                            color="error"
                                                            fab
                                                            x-small
                                                            depressed
                                                            @click="removeVariable(cell[0], index)"
                                                    >-</v-btn>
                                                </v-col>
                                                </v-row>
                                            </v-col>
                                        </div>
                                    </v-flex>
                                </v-layout>

                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
    
</template>

<script>
import moduleLabels from '../../moduleLabels'
import { mapGetters } from 'vuex'
import ModuleCombobox from '../../ModuleCombobox'
import ModuleSelect from '../../ModuleSelect'
import ModuleConditions from '../ModuleConditions'
import ModuleVariablesIfElseSelects from '../ModuleVariablesIfElseSelects'
import ModuleVariablesIfElseSelectsArray from '../moduleIfElseSelectsArray/ModuleVariablesIfElseSelectsArray'
import ModuleMarketConditions from '../ModuleMarketConditions'

export default {
    name: 'MessageForm',
    components: {
        ModuleCombobox,
        ModuleSelect,
        ModuleConditions,
        ModuleVariablesIfElseSelects,
        ModuleVariablesIfElseSelectsArray,
        ModuleMarketConditions
    },
    data() {
        return {
            show: false,
            snackbar: false,
            moduleBlock: false,
            modules: [],
            structure: {}
        }
    },
    props: ['inStructure', 'indexStructure', 'dialog'],
    methods: {
        saveValue: function () {
            this.$emit('updateModules', this.structure)
        },
        loadModel(indexStructure) {
            this.structure = Object.assign({}, this.inStructure[indexStructure])
        },
        getGroupElement(groupType, groupElement) {
            groupElement = groupElement.replace(/\d/g, '')
            return moduleLabels[this.groupName][groupType][groupElement]
        },
        getModuleLabel(groupType, groupElement) {
            let addWord = ''
            if (moduleLabels[this.groupName][groupType].type) {
                if (moduleLabels[this.groupName][groupType].type === 1) {
                    addWord = ' ' + groupElement.replace(/\D/g, '')
                    groupElement = groupElement.replace(/\d/g, '')
                }
            }
            return moduleLabels[this.groupName][groupType][groupElement].label + addWord
        },
        getModuleTitle(groupType) {
            return moduleLabels[this.groupName][groupType].title
        },
        getModuleType(groupType) {
            if (moduleLabels[this.groupName][groupType].hasOwnProperty('type')) {
                return moduleLabels[this.groupName][groupType].type
            } else {
                return false
            }
        },
        getSelectItems(groupType, groupElement) {
            return moduleLabels[this.groupName][groupType][groupElement].items
        },
        addVariable(groupType) {
            let params = []
            for (let param in moduleLabels[this.groupName][groupType]) {
                if (moduleLabels[this.groupName][groupType][param].hasOwnProperty('type')) {
                    params.push(param)
                }
            }
            if (params.length > 0) {
                let lenghtArray = this.structure[this.groupNameFull][groupType].length
                let index
                if (this.structure[this.groupNameFull][groupType].length > 0) {
                    index = parseInt(this.structure[this.groupNameFull][groupType][lenghtArray - 1][0].replace(/\D+/g, '')) + 1
                } else {
                    index = 1
                }
                for (let param in params) {
                    param = params[param] + index
                    this.structure[this.groupNameFull][groupType].push([param, ''])
                }
            }
        },
        removeVariable(cell, groupType) {
            let index = parseInt(cell.replace(/\D+/g, ''))
            for (let i = this.structure[this.groupNameFull][groupType].length - 1; i >= 0; i--) {
                let index1 = parseInt(this.structure[this.groupNameFull][groupType][i][0].replace(/\D+/g, ''))
                if (index1 === index) {
                    this.structure[this.groupNameFull][groupType].splice(i, 1)
                }
            }
        },
        updateItemsCombobox(payload) {
            this.structure[payload.methodId][payload.index][payload.indexCell][1] = payload.items
        }
    },
    filters: {
        truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix
            } else {
                return text
            }
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'moduleGroups/moduleGroups',
            getTitleMethodById: 'modules/getTitleMethodById'
        }),
        groupName() {
            return Object.keys(this.structure)[0].split('.')[0] ? Object.keys(this.structure)[0].split('.')[0] : ''
        },
        groupNameFull() {
            return Object.keys(this.structure)[0].split('.')[0] ? Object.keys(this.structure)[0] : ''
        }
    },
    watch: {
        dialog(value) {
            value === true ? this.show = true : this.show = false
        },
        show(value) {
            if (value === false) {
                this.$emit('close')
            } else {
                this.loadModel(this.indexStructure)
            }
        }
    },
    created() {
        this.show = false
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
        .container {
          width: 100vw;
          height: 70vh;
          display: flex;
          flex-direction: column;
        }
    .titlebar {
      flex-shrink: 0;
    }

    .content {
      flex-grow: 1;
      overflow-x: auto;
    }
</style>
